export default __webpack_public_path__ + "static/media/GreaseCar.90be972b.pdf";